import React from 'react';
import Box from '@mui/material/Box';

const BaseHeader = ({ children }) => {
  return (
    <Box sx={{
      display:'flex',
      flexDirection: 'row',
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      height: '50px',
      boxSizing: 'border-box',
      color: '#fff',
      padding: '2px',
      backgroundColor: '#000000',
      // borderRadius: '3px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: '"Comic Sans MS", "Arial", sans-serif'
      }}>
      {children}
    </Box>
  );
};

export default BaseHeader;
